import { render, staticRenderFns } from "./AbkSuggestDictionaryWordModal.vue?vue&type=template&id=237f8723&scoped=true&"
import script from "./AbkSuggestDictionaryWordModal.vue?vue&type=script&lang=js&"
export * from "./AbkSuggestDictionaryWordModal.vue?vue&type=script&lang=js&"
import style0 from "./AbkSuggestDictionaryWordModal.vue?vue&type=style&index=0&id=237f8723&scoped=true&lang=scss&"
import style1 from "./AbkSuggestDictionaryWordModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237f8723",
  null
  
)

export default component.exports